export default __webpack_public_path__ + "static/customIcons-8d35b177be701ddb35ad7fe042930aeb.gif";